"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const React = require("react");
const react_i18next_1 = require("react-i18next");
const GameTableStyle_1 = require("../../../jss/GameTableStyle");
const iframe_utils_1 = require("../../utils/iframe-utils");
const validation_utils_1 = require("../../utils/validation-utils");
const PastDrawingResultsTableItem_1 = require("./PastDrawingResultsTableItem");
const PastDrawingResultsTableItemSingle = ({ jackpotResultsGrouped, menuItem, gameId, classes, t }) => {
    const defaultJackpotResult = jackpotResultsGrouped === null || jackpotResultsGrouped === void 0 ? void 0 : jackpotResultsGrouped.jackpotResults[0];
    const defaultData = defaultJackpotResult === null || defaultJackpotResult === void 0 ? void 0 : defaultJackpotResult.resultData;
    const defaultWinningNumber = defaultData === null || defaultData === void 0 ? void 0 : defaultData[0]['data'];
    const defaultPrize = defaultJackpotResult['cashAmount'];
    const [jackpotResults] = React.useState(jackpotResultsGrouped === null || jackpotResultsGrouped === void 0 ? void 0 : jackpotResultsGrouped.jackpotResults);
    const [draw, setDraw] = React.useState(defaultJackpotResult);
    const [winningNumber, setWinningNumber] = React.useState(defaultWinningNumber);
    const [winningPrize, setWinningPrize] = React.useState(defaultPrize);
    const columnDivider = jackpotResults[0].multiplier ? 5 : 3;
    const [showIFrame, setShowIFrame] = React.useState(false);
    const valid = (0, validation_utils_1.validateSingle)(draw);
    React.useEffect(() => {
        window.addEventListener('message', receiveMessage, false);
        return () => {
            window.removeEventListener('message', receiveMessage, false);
        };
    });
    const getGameData = (quickDrawResult) => {
        var _a;
        const drawId = draw === null || draw === void 0 ? void 0 : draw.externalId;
        const drawResult = (draw === null || draw === void 0 ? void 0 : draw.resultData) && ((_a = draw === null || draw === void 0 ? void 0 : draw.resultData) === null || _a === void 0 ? void 0 : _a.length) > 0 ? draw === null || draw === void 0 ? void 0 : draw.resultData.map(d => d.data) : [];
        setWinningNumber(drawResult && (drawResult === null || drawResult === void 0 ? void 0 : drawResult.length) > 0 ? drawResult[0] : '0');
        setWinningPrize(draw.cashAmount);
        const availableDraws = getAvailableDraws(quickDrawResult);
        return {
            gameId,
            drawId,
            winningNumber,
            winningPrize,
            availableDraws
        };
    };
    const getAvailableDraws = (quickDrawResult) => {
        const availableDraws = {};
        quickDrawResult === null || quickDrawResult === void 0 ? void 0 : quickDrawResult.forEach(r => {
            if (r['resultData'] && r['resultData'].length > 0) {
                availableDraws[r.externalId] = {
                    winningNumber: r['resultData'][0]['data'],
                    winningPrize: r['cashAmount']
                };
            }
        });
        return availableDraws;
    };
    const receiveMessage = async (event) => {
        if (!showIFrame)
            return;
        (0, iframe_utils_1.sendDataToIframe)(event, getGameData(jackpotResults));
    };
    const selectDraw = (event) => {
        setShowIFrame(false);
        const selectedDrawId = event.target.value;
        const selectedDraw = jackpotResults === null || jackpotResults === void 0 ? void 0 : jackpotResults.filter(j => j.externalId === selectedDrawId)[0];
        if (selectedDraw && (selectedDraw === null || selectedDraw === void 0 ? void 0 : selectedDraw.resultData) && (selectedDraw === null || selectedDraw === void 0 ? void 0 : selectedDraw.resultData.length) > 0) {
            setWinningNumber(selectedDraw['resultData'][0]['data']);
            setWinningPrize(selectedDraw['cashAmount']);
            setDraw(selectedDraw);
        }
    };
    return ((0, jsx_runtime_1.jsx)(PastDrawingResultsTableItem_1.default, Object.assign({ drawDate: jackpotResultsGrouped.drawDate, menuItem: menuItem, onSelectDraw: selectDraw, gameUrl: jackpotResultsGrouped.gameUrl, columnDivider: columnDivider, draw: draw, valid: valid, updateIFrameVisibility: setShowIFrame, showIFrame: showIFrame }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.gameDetailsDataRevealedSD }, { children: [(0, jsx_runtime_1.jsxs)(core_1.Typography, Object.assign({ variant: 'body2', className: classes.gameDetailsDataRevealedFontOTWSD }, { children: [t('gameDetails.winningPrize'), ": $", winningPrize] })), (0, jsx_runtime_1.jsxs)(core_1.Typography, Object.assign({ variant: 'body2', className: classes.gameDetailsDataRevealedFontOTWSD }, { children: [t('gameDetails.winningNumber'), ": ", winningNumber ? parseInt(winningNumber, 10) : ''] }))] })) })));
};
exports.default = (0, core_1.withStyles)(GameTableStyle_1.default)((0, react_i18next_1.withTranslation)()(PastDrawingResultsTableItemSingle));
//# sourceMappingURL=PastDrawingResultsTableItemSingle.js.map